module.exports = __webpack_public_path__ + "img/Newbie_Shield_01_Ranger.10798ff6.png";